import { actionsKeys, mapActionsToBooleans, permissionActions, ROLE_BOM } from "@/lib/utils";
import { setAccessPermission, setMasterDataPermission, setStateData } from "@/redux/slices";
import { RootState } from "@/redux/store";
import { useGetCurrentUserPermission, useGetState } from "@/services";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

const useLayout = () => {
  const dispatch = useDispatch();

  const stateList = useSelector(
    (state: RootState) => state.currentData.stateData
  );
  const communityData = useSelector(
    (state: RootState) => state.currentData.communityData
  );
  const currentRole = useSelector(
    (state: RootState) => state.currentData.currentRole
  );

  const isCamBom = location.pathname.startsWith("/cam") || location.pathname.startsWith("/bom") || (location.pathname.startsWith("/owner") && currentRole == ROLE_BOM);

  const isMasterData =
    location.pathname === "/admin/master-data" ||
    location.pathname.startsWith("/admin/master-data/") ||
    location.pathname === "/cam/master-data" ||
    location.pathname.startsWith("/cam/master-data/") ||
    location.pathname === "/owner/master-data" ||
    location.pathname.startsWith("/owner/master-data/") ||
    location.pathname === "/bom/master-data" ||
    location.pathname.startsWith("/bom/master-data/");

  const isAdminConsole = location.pathname === "/admin/admin-console" ||
  location.pathname.startsWith("/admin/admin-console/");

  const isActivityDashboard =
    location.pathname.startsWith("/admin/activity-dashboard") ||
    location.pathname.startsWith("/cam/activity-dashboard");

  const { data: state, isLoading: isStateLoading } = useGetState({
    queryParams: {
      enabled: !isActivityDashboard && !stateList,
    },
  });

  const { data: userPermission, isLoading: isUserPermissionLoading } =
    useGetCurrentUserPermission({
      communityId: communityData?.communityId,
      queryParams: {
        enabled: !!(communityData?.communityId && isCamBom),
      },
    });

  useEffect(() => {
    if (userPermission?.data && isCamBom) {
      let obj: any = {};

      userPermission?.data?.map((data: any) => {
        obj = {
          ...obj,
          [data?.module?.toLowerCase()]: mapActionsToBooleans(data?.actions),
        };
      });
      
      dispatch(setMasterDataPermission({
        view: obj[actionsKeys?.MASTER_DATA?.toLowerCase()]?.[permissionActions.READ],
        add: obj[actionsKeys?.MASTER_DATA?.toLowerCase()]?.[permissionActions.CREATE],
        update: obj[actionsKeys?.MASTER_DATA?.toLowerCase()]?.[permissionActions.UPDATE],
        delete: obj[actionsKeys?.MASTER_DATA?.toLowerCase()]?.[permissionActions.DELETE],
      }))
      dispatch(setAccessPermission(obj));
    }
  }, [userPermission]);
    
  useEffect(() => {
    dispatch(setStateData(state?.data));
  }, [state]);

  return {
    isMasterData,
    isStateLoading,
    isUserPermissionLoading,
    isAdminConsole
  };
};

export default useLayout;
